import { ModelBase } from 'store/model-base';
import { ReturnStatus } from 'my-account/constants';

export class OrderReturnInfo extends ModelBase {
    public static storeName: string = 'orderReturnInfo';
    public static idAttribute: string = 'orderId.key';

    public orderId: Id;
    public status: ReturnStatus;
    public date: string;
    public grade: ReturnGrade;
}
